import { createAction } from 'typesafe-actions';
import { CustomerOrder, StoreCredit } from 'types/types';

export const setOrder = createAction('@order/SET_ORDER')<CustomerOrder>();
export const setStoreCreditRemaining = createAction(
  '@order/SET_STORE_CREDIT_REMAINING'
)<StoreCredit>();

export const clearOrder = createAction('@order/CLEAR_ORDER')();
